
import api from '../api';

/**
 * Fetch details of an order using the provided order ID.
 *
 * @param {string} orderID - The ID of the order to fetch details for.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const getOrder = async (orderID) => {
  if (!orderID) {
    throw new Error('userId is required.');
  }

  const endpoint = process.env.REACT_APP_API_ENDPOINT + "/api/user/order?order_id=" + encodeURIComponent(orderID);

  try {
    const response = await api.get(endpoint);

    return response.data;
  } catch (error) {
    console.error('Error while fetching order:', error);
    throw error;
  }
}

export default getOrder;
